<template>
  <ul class="accordion"
    data-accordion data-multi-expand="true"
    data-allow-all-closed="true">
      <template v-for="(item, index) in listitems">
        <li :class="{ 'accordion-item': true, 'is-active': isExpanded(index) }" 
          v-if="item.doc_ficheiros?.length > 0"
          data-accordion-item>
          <a href="#" class="accordion-title" 
            @click.prevent="toggleAccordion(index)">
              <img :src="image" />
              {{ item.doc_titulo }}
          </a>
          <div class="accordion-content" :id="`item${index}`">
            <contentitem 
              class="citem"
              :item="item"/>
          </div>
        </li>
      </template>
  </ul>
</template>

<script>
import image from "@/assets/galerias_girp-24-18.png";
import contentitem from "@/components/listac/contentitem.vue";
import $ from 'jquery';
import { ref } from 'vue';

export default {
  props: ["listitems"],
  components:{
    contentitem
  },
  setup(props) {

    const expandedItems = ref([]);

    const toggleAccordion = (index) => {
      const selector = `#item${index}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        expandedItems.value.push(index);
        $content.slideDown(() => { });
      }
    };

    const isExpanded = (index) => expandedItems.value.includes(index);

    return {
      image,
      toggleAccordion,
      isExpanded
    }
  }
}
</script>

<style scoped>
.accordion-content {
  background-color: transparent;
  border: transparent;
}

.accordion-content p {
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}

.accordion-title:before {
  font-size: 25px;
  margin-top: -19px;
}

.accordion-title {
  border: transparent;
  color: #707475;
  font-size: 15px;
  line-height: 1.5;
  padding: 11px 70px 11px 0px;
  border: transparent;
  border-bottom: 1px solid #a7a5a5;
  font-family: 'Montserrat';
}

.accordion-title:hover,
.accordion-title:focus {
  background-color: transparent;
  color: #707475;
}

:last-child:not(.is-active)>.accordion-title {
  border-bottom: transparent;
}

:last-child>.accordion-content:last-child {
  border-bottom: transparent;
}

.accordion-title,
.accordion-item {
  background-color: transparent;
}


.accordion {
  background-color: transparent;
}

@media (max-width: 676px) {

  .accordion {
    background-color: transparent;
  }

  .accordion:first-of-type {
    border-top: 1px solid #a7a5a5;
  }

  .accordion:last-of-type {
    border-bottom: 1px solid #a7a5a5;
    margin-bottom: 10px;
  }

  .accordion-title {
    margin-left: 0;
    line-height: 1.2;
    font-family: "Montserrat";
    font-size: 13px;
    padding-right: 50px;
    padding-top: 8px;
    padding-bottom: 8px;
    color: #707475;
    background-color: transparent;
  }

  .accordion-title:before {
    right: 5px;
  }

  .accordion-content {
    border: transparent;
    padding-right: 0;
    padding-left: 0;
  }

  .accordion-content p {
    font-size: 14px;
    line-height: 1.9;
    padding-left: 0;
  }
}

/*novas*/
.accordion-title img {
  width: 87.48px;
  height: auto;
  margin-right: 17px;
}

.accordion-title {
  font-family: "Montserrat Bold";
  font-size: 17px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.accordion-title:before {
  content: '\f078';
  font-family: FontAwesome;
  font-size: 20px;
}

.accordion-item.is-active>.accordion-title::before {
  font-family: FontAwesome;
  content: '\f077';
  font-size: 20px;
}

.accordion-content{
  margin-left: 8.33333%;
}

@media screen and (max-width:1024px) {
  .accordion-content{
    margin-left: 0;
  }

  .accordion-title {
    font-size: 15px;
    flex-wrap: nowrap;
  }

  .accordion-title img {
    margin-right: 7px;
    width: 90px;
  }

}

@media (max-width: 767px) {
  .accordion-content{
    margin-left: 0;
    padding-left: 0;
  }

  .accordion-title img {
    width: 70px;
  }
}

</style>